module.exports = __webpack_public_path__ + "img/create-resume.d36e8781.svg";